// ChildNode.remove polyfill for IE
// https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/remove#Polyfill
// https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
(function (arr) {
    arr.forEach(function (item) {
        item.remove = item.remove || function () {
            this.parentNode.removeChild(this);
        };
    });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);